import { StaticImageData } from 'next/image'
import { GetDTLOriginalRes } from 'src/types'

type NumStr = number | string

export const getVideoIDs = ({ data }: GetDTLOriginalRes): string[] => {
  return data.map((vid) => {
    return vid.attributes.videoID
  })
}
export const getVideoIDsV2 = (
  data: {
    img: StaticImageData | string
    views: number
    title: string
    videoID: string
  }[]
): string[] => {
  return data.map((vid) => {
    return vid.videoID
  })
}

export const removeElement = (val: NumStr, arr: NumStr[]) => {
  const idx = arr.indexOf(val)
  return arr.filter((val) => val !== arr[idx])
}
